import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Checkbox, I18n } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ExpensesFilters = ({
  section,
  filters,
  onlyFreeActions,
  toggleFilter,
  toggleOnlyPaidFilter,
  className,
}) => {
  if (!filters || !filters.length) {
    return null;
  }

  return (
    <div className={cx(className)}>
      {filters.map((filter) => filter.visibleIn[section] && !filter.hidden && (
        <div
          key={`filter-${section}-${filter.id}`}
          className={cx('filter', 'parentFilter')}
        >
          <Checkbox
            name={`filter-${section}-${filter.id}`}
            checked={filter.activeIn[section]}
            handleChange={() => toggleFilter({
              section,
              filterId: filter.id,
              checked: !filter.activeIn[section],
            })}
          >
            {filter.name}
          </Checkbox>
          {filter.children && (
            <ExpensesFilters
              className={cx('nestedFilter')}
              section={section}
              filters={filter.children}
              toggleFilter={toggleFilter}
              nested
            />
          )}
        </div>
      ))}
      {toggleOnlyPaidFilter && (
        <div className={cx('onlyPaid')}>
          <Checkbox
            name="filter-only-paid"
            checked={!!onlyFreeActions}
            handleChange={toggleOnlyPaidFilter}
          >
            <I18n path="detalization.expenses.onlyPaidFilter" />
          </Checkbox>
        </div>
      )}
    </div>
  );
};

ExpensesFilters.propTypes = {
  section: PropTypes.string,
  filters: PropTypes.array,
  toggleFilter: PropTypes.func,
  className: PropTypes.any,
  onlyFreeActions: PropTypes.bool,
  toggleOnlyPaidFilter: PropTypes.func,
};

export default ExpensesFilters;
